import { BugIcon, BuildingIcon, GlobeIcon, KeyIcon, Users2Icon } from 'lucide-react';

import AppSidebar from 'components/app-layout/Sidebar';
import AppSidebarItem from 'components/app-layout/SidebarItem';

function AdminSidebar() {
  return <AppSidebar>
    <AppSidebarItem
      to='/admin/organizations'
      icon={BuildingIcon}
      alias='Organizations'
    />
    <AppSidebarItem
      to='/admin/sites'
      icon={GlobeIcon}
      alias='Sites'
    />
    <AppSidebarItem
      to='/admin/users'
      icon={Users2Icon}
      alias='Users'
    />
    <AppSidebarItem
      to='/admin/app-error'
      icon={BugIcon}
      alias='App Errors'
    />
    <AppSidebarItem
      to="/admin/tokens"
      icon={KeyIcon}
      alias='Tokens'
    />
  </AppSidebar>
}
export default AdminSidebar
